import { AlertTriangle } from "lucide-react";

const NoticeCard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="border-state-notice-1 flex overflow-hidden rounded-md border">
      <div className="bg-bg-notice-1 flex flex-col items-center justify-start px-2 py-4 md:justify-center md:p-4">
        <AlertTriangle className="text-state-notice-1 size-6 md:size-8" />
      </div>
      <div className="p-4">{children}</div>
    </div>
  );
};

export default NoticeCard;
